/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import {
  getPromptV2Client,
  handlePromptServiceError as handlePromptStoreError
} from '../../../../common/prompt/promptV2Client';

export { getPromptV2Client };

export const handlePromptServiceError = (error, fallbackMsg, errorEvent) => {
  handlePromptStoreError(error, fallbackMsg, errorEvent, 'studioPromptModel');
};
